import React from 'react';
import { MessageSquare, FileText, CreditCard, Code, Eye, Rocket } from 'lucide-react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'Contacto',
  desc: 'Escríbenos por WhatsApp',
  icon: MessageSquare
}, {
  title: 'Información',
  desc: 'Envíanos tus datos y fotos',
  icon: FileText
}, {
  title: 'Anticipo',
  desc: 'Solo $125 para empezar',
  icon: CreditCard
}, {
  title: 'Construcción',
  desc: 'Diseñamos tu website',
  icon: Code
}, {
  title: 'Revisión',
  desc: 'Apruebas el resultado',
  icon: Eye
}, {
  title: 'Lanzamiento',
  desc: 'Tu página en vivo',
  icon: Rocket
}];
export function ProcessSection() {
  return <section className="py-24 bg-dark-100 overflow-hidden" data-id="element-367">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-368">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-369">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-370">
            Listo En Menos De 72 Horas.{' '}
            <span className="text-gold" data-id="element-371">Así De Simple.</span>
          </h2>
        </motion.div>

        <div className="relative" data-id="element-372">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-dark-100 via-gold/30 to-dark-100 -translate-y-1/2 z-0" data-id="element-373"></div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 relative z-10" data-id="element-374">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col items-center text-center group" data-id="element-375">
                <div className="w-16 h-16 rounded-full bg-dark border-2 border-white/10 flex items-center justify-center text-gray-400 group-hover:border-gold group-hover:text-gold group-hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] transition-all duration-300 mb-4 relative" data-id="element-376">
                  <step.icon className="w-6 h-6" data-id="element-377" />
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-gold text-dark text-xs font-bold rounded-full flex items-center justify-center" data-id="element-378">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-white font-bold mb-1" data-id="element-379">{step.title}</h3>
                <p className="text-gray-500 text-xs" data-id="element-380">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}